import { modulePermissionsNames } from "./modulePermissionsNames";

export default {
  [modulePermissionsNames.SET_PERMISSIONS](state: any, payload: any): void {
    state.permissions = payload;
  },
  [modulePermissionsNames.SET_PERMISSIONS_OBJ](state: any, payload: any): void {
    state.permissionsObj = payload;
  },
  [modulePermissionsNames.SET_PERMISSIONS_PAGE](
    state: any,
    payload: { pageName: string; value: boolean }
  ): void {
    state.permissionsPage[payload.pageName] = payload.value;
  },
};
